module.exports = __webpack_public_path__ + "img/22.8ee989c0.jpg";